import { render, staticRenderFns } from "./ItensVenda.vue?vue&type=template&id=67dbcc53"
import script from "./ItensVenda.vue?vue&type=script&lang=js"
export * from "./ItensVenda.vue?vue&type=script&lang=js"
import style0 from "./ItensVenda.vue?vue&type=style&index=0&id=67dbcc53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports